import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import OwnershipForm from '../../components/Ownership/OwnershipForm'

function OwnershipEdit() {
    const { id } = useParams()
    const navigate = useNavigate()
    const [selectedItem, setSelectedItem] = useState({})
    // handleGoBack
    const handleGoBack = () => {
        navigate('/ownership-list')
    }
    
    useEffect(() => {
        if(id){
            fetchList()
        }
    },[id])
    // fetch data 
    async function fetchList() {
        try {
            const response = await nbrApi.post('/listownershipgroups')

            const data = response.data
            // setData(data)
            if (data?.length > 0) {
                let filterData = data?.filter(e => e?.pk_id === parseInt(id))
                setSelectedItem(filterData?.[0])
            }
        } catch (error) {
            console.error('Error fetching data:', error.message)
        }
    }
    // create action
    const handleForm = async (data) => {
        console.log(data)
        if (data) {
            try {
                let formData = {
                    ...data,
                    pk_id: Number(id)
                }
                const response = await nbrApi.post('/updateownershipgroup', formData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Ownership Group Updated Successfully',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Ownership Group Updated failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Ownership Group Updated failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Edit Ownership Record</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <OwnershipForm handleAction={handleForm} data={selectedItem} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OwnershipEdit
